import { render, staticRenderFns } from "./EducationProtocolList.vue?vue&type=template&id=64152894&scoped=true&"
import script from "./EducationProtocolList.vue?vue&type=script&lang=ts&"
export * from "./EducationProtocolList.vue?vue&type=script&lang=ts&"
import style0 from "./EducationProtocolList.vue?vue&type=style&index=0&id=64152894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64152894",
  null
  
)

export default component.exports